export default __webpack_public_path__ + "static/media/human_other.eff7f563.png";